import { isValid as isValidCpf } from '@fnando/cpf';
import { isValid as isValidCnpj } from '@fnando/cnpj';

const validateCpfCnpj = documentNumber => {
  if (documentNumber) documentNumber = documentNumber.replace(/\D+/gm).trim();
  return isValidCpf(documentNumber) || isValidCnpj(documentNumber);
};

export default validateCpfCnpj;
